import React, { Component } from "react";
import Flatpickr from "react-flatpickr";
import { Grid, Header, Divider, Form, Message, Modal, Table, Input } from "semantic-ui-react";

import request from "../../utils/request";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y-m-d h:i K"
};

class EventReprint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventId: this.props.match.params.id,
      formLoading: false,
      isLoading: true,
      isMounted: false,
      password: "",
      xhrMessage: "",
      xhrStatus: "",
      printerOptions: [],
      reprintTicketNumber: "",
      reprintFirstTicketNumber: "",
      reprintLastTicketNumber: "",
      reprintStartTime: "",
      reprintEndTime: "",
      searchTicketNumber: "",
      searchRange: 0,
      searchStartTime: "",
      searchEndTime: "",
      printerId: 0,
      tickets: [],
      openReprintModal: false,
      openSearchNumberModal: false,
      openSearchTimeModal: false
    };
    this.fetchPrinters = this.fetchPrinters.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount = () => {
    this.fetchPrinters();
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({
        isLoading: true,
        eventId: this.props.eventId
      });
    }
  };
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }
  handleSubmit = e => {
    this.setState({ formLoading: true, openReprintModal: false });
    //check for reprint request
    if ((e.target && e.target.id === "reprintSingleForm") || e === "reprintMultipleForm") {
      var reprintPayload = {
        eventId: this.state.eventId,
        printerId: this.state.printerId ? this.state.printerId : 0,
        number: this.state.reprintTicketNumber ? this.state.reprintTicketNumber : null,
        startTime: this.state.reprintStartTime ? this.state.reprintStartTime : null,
        endTime: this.state.reprintEndTime ? this.state.reprintEndTime : null,
        firstTicket: this.state.reprintFirstTicketNumber ? this.state.reprintFirstTicketNumber : null,
        lastTicket: this.state.reprintLastTicketNumber ? this.state.reprintLastTicketNumber : null,
        searchCriteria: this.state.reprintStartTime ? "time" : "number",
        password: this.state.password,
        confirmPrint: 1,
        formId: e.target && e.target.id ? e.target.id : "reprintMultipleForm"
      };
      return request.post(this, "api:/drum-printer/reprint", reprintPayload).then(resp => {
        this.setState({
          formLoading: false,
          xhrStatus: resp.status,
          xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? "Success!" : resp.message),
          respFormId: resp.formId,
          password: ""
        });

      });
    }
  };
  handleView = () => {
    this.setState({ openReprintModal: true, isLoading: true })
    var reprintPayload = {
      eventId: this.state.eventId,
      printerId: this.state.printerId ? this.state.printerId : 0,
      number: this.state.reprintTicketNumber ? this.state.reprintTicketNumber : null,
      startTime: this.state.reprintStartTime ? this.state.reprintStartTime : null,
      endTime: this.state.reprintEndTime ? this.state.reprintEndTime : null,
      firstTicket: this.state.reprintFirstTicketNumber ? this.state.reprintFirstTicketNumber : null,
      lastTicket: this.state.reprintLastTicketNumber ? this.state.reprintLastTicketNumber : null,
      searchCriteria: this.state.reprintStartTime ? "time" : "number",
      confirmPrint: 0
    };
    return request.post(this, "api:/drum-printer/reprint", reprintPayload).then(resp => {
      this.setState({
        formLoading: false,
        tickets: resp,
        xhrStatus: resp.status,
        xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? "Success!" : resp.message),
        isLoading: false
      });
    });
  }
  handleSearch = e => {
    this.setState({ 
      openSearchNumberModal: e === "searchByNumberForm" ? true : false, 
      openSearchTimeModal: e === "searchByTimeForm" ? true : false,
      isLoading: true ,
      tickets: []
    });
    //check for search request
    if (e === "searchByNumberForm" || e === "searchByTimeForm") {
      var searchPayload = {
        eventId: this.state.eventId,
        printerId: this.state.printerId ? this.state.printerId : 0,
        number: !this.state.searchTicketNumber ? null : (e === "searchByNumberForm" ? this.state.searchTicketNumber : null),
        range: !this.state.searchRange ? null : (e === "searchByNumberForm" ? this.state.searchRange : 0),
        startTime: !this.state.searchStartTime ? null : (e === "searchByTimeForm" ? this.state.searchStartTime : null),
        endTime: !this.state.searchEndTime ? null :  (e === "searchByTimeForm" ? this.state.searchEndTime : null),
        searchCriteria: e === "searchByNumberForm" ? "number" : "time",
        formId: e ? e : ""
      }
      return request.post(this, "api:/drum-printer/find-ticket", searchPayload).then(resp => {
        this.setState({
          formLoading: false,
          tickets: resp,
          xhrStatus: resp.status,
          xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? "Success!" : resp.message),
          isLoading: false
        });
      });
    }
  }
  fetchPrinters = () => {
    return request.get(this, "api:/drum-printer", {}).then(resp => {                  
      let printerSelect = [];
      if (resp && resp.status !== "error") {
        resp.map(v => {
          return printerSelect.push({
            id: v.id,
            value: v.id,
            text: v.label == null ? v.host : v.host + ' (' + v.label + ')'
          });
        });
      }
      this.setState({ printerOptions: printerSelect }, this.doneLoading);
    });


  };
  handleModal = () => {
    this.setState({ openReprintModal: false, openSearchNumberModal: false, openSearchTimeModal: false, password: "" });
  }
  render() {
    const {
      isLoading,
      formLoading,
      xhrMessage,
      xhrStatus,
      printerOptions,
      respFormId,
      tickets,
      openReprintModal,
      openSearchNumberModal,
      openSearchTimeModal
    } = this.state;

    return (
      <Grid columns={2} divided loading={isLoading ? "true" : "false"}>
        <Grid.Row>
          <Grid.Column>
            <Header>RE-PRINT SINGLE TICKET</Header>
            <Header.Subheader>This tool will allow you to re-print a single ticket by entering the number below.</Header.Subheader>
            <Divider hidden></Divider>
            <Form
              id="reprintSingleForm"
              loading={respFormId === "reprintSingleForm" ? formLoading : false}
              success={xhrStatus === "success"}
              error={xhrStatus === "fail"}
              onSubmit={this.handleSubmit}
            >
              {respFormId === "reprintSingleForm" && <Message success content={xhrMessage} />}
              {respFormId === "reprintSingleForm" && <Message error content={xhrMessage} />}
              <Form.Select placeholder='Select a printer' options={printerOptions} name="printerId" onChange={this.handleChange} />
              <Form.Input placeholder='Enter the ticket #' type="number" step="any" onChange={this.handleChange} name="reprintTicketNumber" />
              {this.state.reprintTicketNumber && <Form.Input
                placeholder='Please enter your password'
                type="password"
                onChange={this.handleChange}
                name="password"
              />}
              <Form.Button
                primary
                content='Reprint'
                icon='print'
                disabled={!this.state.reprintTicketNumber || !this.state.password}
              />
            </Form>
          </Grid.Column>
          <Grid.Column>
            <Header>SEARCH TICKETS BY NUMBER</Header>
            <Header.Subheader>Enter a ticket number below, then click "Search Tickets" to find a list of tickets that were printed immediately before and immediately after the number entered.</Header.Subheader>
            <Divider hidden></Divider>
            <Form id="searchByNumberForm">
              <Form.Select placeholder='Select a printer' options={printerOptions} name="printerId" onChange={this.handleChange} />
              <Form.Group inline>
                <Form.Input placeholder='Enter the ticket #' type="number" name="searchTicketNumber" step="any" onChange={this.handleChange} width={8} />
                <Form.Input placeholder='Enter the range' type="number" name="searchRange" onChange={this.handleChange} width={8} />
              </Form.Group>
              <Modal
                closeIcon
                open={openSearchNumberModal}
                trigger={<Form.Button
                  primary
                  content='Search'
                  icon='search'
                  disabled={!this.state.searchTicketNumber && !this.state.searchRange}
                  onClick={() => this.handleSearch("searchByNumberForm")}
                />}
                onClose={() => this.handleModal()}
              >
                <Header icon='archive' content='Tickets' />
                <Modal.Content scrolling loading={isLoading ? "true" : "false"}>
                  <Table celled compact>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Drum Id</Table.HeaderCell>
                        <Table.HeaderCell>Print Time</Table.HeaderCell>
                        <Table.HeaderCell>Number</Table.HeaderCell>
                        <Table.HeaderCell>Purchase Time</Table.HeaderCell>
                        <Table.HeaderCell>Host</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {tickets && tickets.tickets && Object.keys(tickets.tickets).map((v, k) =>
                        <Table.Row key={k}>
                          <Table.Cell>{tickets.tickets[k]['drumId']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['printTime']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['number']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['purchaseTime']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['host']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['status']}</Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Modal.Content>
                <Modal.Actions>
                  <Form.Button
                    primary
                    content='Close'
                    icon='close'
                    onClick={() => this.handleModal()}
                  />
                </Modal.Actions>
              </Modal>
            </Form>
          </Grid.Column>
        </Grid.Row>
        <Divider horizontal>OR</Divider>
        <Grid.Row>
          <Grid.Column>
            <Header>RE-PRINT MULTIPLE TICKETS</Header>
            <Header.Subheader>To re-print a range of tickets, select the printer and then enter the first and last ticket numbers below. All tickets between the two numbers entered (including the numbers entered) will be re-printed. Note that the order of the ticket numbers entered does not matter.</Header.Subheader>
            <Divider hidden></Divider>
            <Form
              id="reprintMultipleForm"
              loading={respFormId === "reprintMultipleForm" ? formLoading : false}
              success={xhrStatus === "success"}
              error={xhrStatus === "fail"}
              onSubmit={this.handleSubmit}
            >
              {respFormId === "reprintMultipleForm" && <Message success content={xhrMessage} />}
              {respFormId === "reprintMultipleForm" && <Message error content={xhrMessage} />}
              <Form.Select placeholder='Select a printer' options={printerOptions} name="printerId" onChange={this.handleChange} />
              <Form.Group inline>
                <Form.Input
                  placeholder='Enter the first ticket #'
                  name="reprintFirstTicketNumber"
                  type="number"
                  onChange={this.handleChange}
                  width={8}
                  disabled={this.state.reprintStartTime || this.state.reprintEndTime}
                />
                <Form.Input
                  placeholder='Enter the last ticket #'
                  name="reprintLastTicketNumber"
                  type="number"
                  onChange={this.handleChange}
                  width={8}
                  disabled={this.state.reprintStartTime || this.state.reprintEndTime}
                />
              </Form.Group>
              <Form.Group inline>
                <Form.Field width={8} disabled={this.state.reprintFirstTicketNumber || this.state.reprintLastTicketNumber}>
                  <Flatpickr
                    name="reprintStartTime"
                    placeholder="Start Time"
                    autoComplete="off"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "reprintStartTime",
                        value: str
                      })
                    }
                  />
                </Form.Field>
                <Form.Field width={8} disabled={this.state.reprintFirstTicketNumber || this.state.reprintLastTicketNumber}>
                  <Flatpickr
                    name="reprintEndTime"
                    placeholder="End Time"
                    autoComplete="off"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "reprintEndTime",
                        value: str
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group inline>
                <Modal
                  closeIcon
                  open={openReprintModal}
                  trigger={<Form.Button
                    type="button"
                    primary
                    content='View Tickets'
                    icon='search'
                    disabled={(!this.state.reprintFirstTicketNumber && !this.state.reprintStartTime) || this.state.password}
                    onClick={() => this.handleView()}
                  />}
                  onClose={() => this.handleModal()}
                >
                  <Header icon='archive' content='Tickets' />
                  <Modal.Content scrolling loading={isLoading ? "true" : "false"}>
                    <Table celled compact>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>Drum Id</Table.HeaderCell>
                          <Table.HeaderCell>Print Time</Table.HeaderCell>
                          <Table.HeaderCell>Number</Table.HeaderCell>
                          <Table.HeaderCell>Purchase Time</Table.HeaderCell>
                          <Table.HeaderCell>Host</Table.HeaderCell>
                          <Table.HeaderCell>Status</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {tickets && tickets.tickets && Object.keys(tickets.tickets).map((v, k) => 
                          <Table.Row key={k}>
                            <Table.Cell>{tickets.tickets[k]['drumId']}</Table.Cell>
                            <Table.Cell>{tickets.tickets[k]['printTime']}</Table.Cell>
                            <Table.Cell>{tickets.tickets[k]['number']}</Table.Cell>
                            <Table.Cell>{tickets.tickets[k]['purchaseTime']}</Table.Cell>
                            <Table.Cell>{tickets.tickets[k]['host']}</Table.Cell>
                            <Table.Cell>{tickets.tickets[k]['status']}</Table.Cell>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>
                  </Modal.Content>
                  <Modal.Actions>
                    {(this.state.reprintFirstTicketNumber || this.state.reprintStartTime) && <Input
                      placeholder='Enter your password'
                      type="password"
                      onChange={this.handleChange}
                      name="password"
                    />}
                    <Divider hidden/>
                    <Form.Button
                      primary
                      content='Reprint'
                      icon='print'
                      disabled={(!this.state.reprintFirstTicketNumber && !this.state.reprintStartTime) || !this.state.password}
                      onClick={() => this.handleSubmit("reprintMultipleForm")}
                    />
                </Modal.Actions>
                </Modal>
              </Form.Group>
            </Form>
          </Grid.Column>
          <Grid.Column>
            <Header>SEARCH TICKETS BY TIME</Header>
            <Header.Subheader>Enter the "Drum" time from a ticket here to find all tickets printed by a printer at a specific time. You may also enter an "End Time" to find all tickets printed between a specific period of time.</Header.Subheader>
            <Divider hidden></Divider>
            <Form id="searchByTimeForm">
              <Form.Select placeholder='Select a printer' options={printerOptions} name="printerId" onChange={this.handleChange} />
              <Form.Group inline>
                <Form.Field width={8}>
                  <Flatpickr
                    name="searchStartTime"
                    placeholder="Start Time"
                    autoComplete="off"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "searchStartTime",
                        value: str
                      })
                    }
                  />
                </Form.Field>
                <Form.Field width={8}>
                  <Flatpickr
                    name="searchEndTime"
                    placeholder="End Time"
                    autoComplete="off"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "searchEndTime",
                        value: str
                      })
                    }
                  />
                </Form.Field>
              </Form.Group>
              <Modal
                closeIcon
                open={openSearchTimeModal}
                trigger={<Form.Button
                  primary
                  content='Search'
                  icon='search'
                  disabled={!this.state.searchStartTime && !this.state.searchEndTime}
                  onClick={() => this.handleSearch("searchByTimeForm")}
                />}
                onClose={() => this.handleModal()}
              >
                <Header icon='archive' content='Tickets' />
                <Modal.Content scrolling loading={isLoading ? "true" : "false"}>
                  <Table celled compact>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Drum Id</Table.HeaderCell>
                        <Table.HeaderCell>Print Time</Table.HeaderCell>
                        <Table.HeaderCell>Number</Table.HeaderCell>
                        <Table.HeaderCell>Purchase Time</Table.HeaderCell>
                        <Table.HeaderCell>Host</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {tickets && tickets.tickets && Object.keys(tickets.tickets).map((v, k) =>
                        <Table.Row key={k}>
                          <Table.Cell>{tickets.tickets[k]['drumId']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['printTime']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['number']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['purchaseTime']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['host']}</Table.Cell>
                          <Table.Cell>{tickets.tickets[k]['status']}</Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Modal.Content>
                <Modal.Actions>
                  <Form.Button
                    primary
                    content='Close'
                    icon='close'
                    onClick={() => this.handleModal()}
                  />
                </Modal.Actions>
              </Modal>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default EventReprint;
